module.exports = __webpack_public_path__ + "img/minus-circle.0a9f2aec.svg";